import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=7ddfda61"
import script from "./Bread.vue?vue&type=script&lang=js"
export * from "./Bread.vue?vue&type=script&lang=js"
import style0 from "./Bread.vue?vue&type=style&index=0&id=7ddfda61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports